import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { backgroundColorNames } from '../../../theme/axiom-theme';
import { ColorUtil } from '../../../utils/color-util';

export const BadgeBackgrounds = Object.values(backgroundColorNames);

export const BadgeFlushes = ['left', 'right'] as const;

export type BadgeBackgroundType = (typeof BadgeBackgrounds)[number];

export type BadgeProps = {
  background: BadgeBackgroundType;
  children?: React.ReactNode;
  className?: string;
  flush?: (typeof BadgeFlushes)[number];
  minimal?: boolean;
  name?: string;
};

export const Badge = ({
  background,
  className,
  children,
  flush,
  minimal,
  name,
}: BadgeProps) => (
  <div
    className={AttrsHelper.formatClassname(
      'axiom-badge',
      ColorUtil.nameClass({ color: background, prefix: 'background' }),
      flush && !minimal && `flush-${flush}`,
      minimal && 'minimal',
      className
    )}
    data-test={name}
  >
    {children}
  </div>
);
